import type { ResumeDocument } from "../api/client";

const UPDATED = "2026-10-01T00:00:00.000Z";

export function sampleDocument(locale: ResumeDocument["locale"] = "en"): ResumeDocument {
  const vi = locale === "vi";
  return {
    id: "sample",
    title: vi ? "Hồ sơ mẫu" : "Sample CV",
    slug: "sample",
    locale,
    visibility: "private",
    templateId: "classic",
    theme: {
      accent: "#1d1d1f",
      fontPair: "serif",
      density: "comfortable",
      pageSize: "a4",
      showAvatar: true,
    },
    layout: {
      sectionOrder: [
        "profile",
        "experience",
        "education",
        "projects",
        "skills",
        "links",
        "languages",
        "certifications",
        "awards",
      ],
      hiddenSections: [],
    },
    profile: {
      fullName: vi ? "Nguyễn Văn A" : "Nguyen Van A",
      headline: vi ? "Kỹ sư Frontend cao cấp" : "Senior Frontend Engineer",
      email: "hello@example.com",
      phone: "+84 90 123 4567",
      location: vi ? "TP. Hồ Chí Minh" : "Ho Chi Minh City",
      summary: vi
        ? "Tôi xây dựng sản phẩm web nhanh, dễ dùng và bền vững. Mười năm kinh nghiệm từ startup đến doanh nghiệp lớn."
        : "I build web products that are fast, easy to use, and built to last. Ten years across startups and large teams.",
      showEmail: true,
      showPhone: true,
      avatarUrl: null,
    },
    education: [
      {
        id: "edu-1",
        institution: vi ? "Đại học Bách khoa" : "University of Technology",
        degree: vi ? "Kỹ sư" : "BEng",
        fieldOfStudy: vi ? "Khoa học máy tính" : "Computer Science",
        location: vi ? "TP. Hồ Chí Minh" : "Ho Chi Minh City",
        startDate: "2012-09",
        endDate: "2016-06",
        isCurrent: false,
        description: null,
        sortOrder: 0,
      },
    ],
    experience: [
      {
        id: "exp-1",
        company: "Northwind",
        role: vi ? "Kỹ sư Frontend cao cấp" : "Senior Frontend Engineer",
        location: vi ? "Từ xa" : "Remote",
        employmentType: "full-time",
        startDate: "2022-03",
        endDate: null,
        isCurrent: true,
        highlights: vi
          ? [
              "Dẫn dắt việc viết lại ứng dụng, giảm 40% thời gian tải.",
              "Thiết lập hệ thống thiết kế dùng chung cho năm nhóm.",
            ]
          : [
              "Led the app rewrite and cut load time by 40%.",
              "Set up a shared design system used by five teams.",
            ],
        sortOrder: 0,
      },
      {
        id: "exp-2",
        company: "Lumen Studio",
        role: vi ? "Kỹ sư phần mềm" : "Software Engineer",
        location: vi ? "Đà Nẵng" : "Da Nang",
        employmentType: "full-time",
        startDate: "2018-01",
        endDate: "2022-02",
        isCurrent: false,
        highlights: vi
          ? ["Xây dựng nền tảng thanh toán phục vụ 200.000 người dùng."]
          : ["Built a payments platform serving 200,000 users."],
        sortOrder: 1,
      },
    ],
    projects: [
      {
        id: "prj-1",
        name: "Atlas",
        role: vi ? "Tác giả" : "Author",
        description: vi
          ? "Bộ công cụ mã nguồn mở giúp nhóm thiết kế và lập trình làm việc cùng nhau."
          : "An open-source toolkit that helps design and engineering teams work together.",
        url: "https://example.com/atlas",
        repoUrl: null,
        startDate: "2021-05",
        endDate: null,
        isCurrent: true,
        highlights: [],
        tech: ["TypeScript", "React", "Cloudflare"],
        imageUrl: null,
        featured: true,
        sortOrder: 0,
      },
    ],
    links: [
      {
        id: "lnk-1",
        type: "linkedin",
        label: "LinkedIn",
        url: "https://linkedin.com/in/example",
        sortOrder: 0,
      },
      {
        id: "lnk-2",
        type: "github",
        label: "GitHub",
        url: "https://github.com/example",
        sortOrder: 1,
      },
    ],
    skills: [
      { id: "skl-1", name: "TypeScript", category: "Engineering", level: 5, sortOrder: 0 },
      { id: "skl-2", name: "React", category: "Engineering", level: 5, sortOrder: 1 },
      { id: "skl-3", name: "Cloudflare", category: "Platform", level: 4, sortOrder: 2 },
      { id: "skl-4", name: "Design systems", category: "Craft", level: 4, sortOrder: 3 },
    ],
    languages: [
      { id: "lng-1", name: vi ? "Tiếng Việt" : "Vietnamese", proficiency: "native", sortOrder: 0 },
      { id: "lng-2", name: "English", proficiency: "fluent", sortOrder: 1 },
    ],
    certifications: [
      {
        id: "cer-1",
        name: "Cloudflare Developer",
        issuer: "Cloudflare",
        issueDate: "2024-04",
        expiryDate: null,
        credentialId: null,
        credentialUrl: null,
        sortOrder: 0,
      },
    ],
    awards: [],
    publishedAt: null,
    updatedAt: UPDATED,
  };
}

export function withTemplate(
  doc: ResumeDocument,
  templateId: string,
  accent: string,
  fontPair: ResumeDocument["theme"]["fontPair"],
  density: ResumeDocument["theme"]["density"],
): ResumeDocument {
  return {
    ...doc,
    templateId,
    theme: { ...doc.theme, accent, fontPair, density },
  };
}
